export class ComplianceSummary {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalResources",
            "baseName": "totalResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "compliantResources",
            "baseName": "compliantResources",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "failuresByControl",
            "baseName": "failuresByControl",
            "type": "Array<ControlFailureCount>",
            "format": ""
        },
        {
            "name": "computedAt",
            "baseName": "computedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return ComplianceSummary.attributeTypeMap;
    }
    constructor() {
    }
}
